<template>
    <dialog :open="open" class="action-dialog">
        <h3>Перенести личную сессию</h3>
        <label>ID нового слота (UUID)
            <input v-model="newSlotId" type="text" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
        </label>
        <div class="actions">
            <button class="btn btn--primary" :disabled="busy || !newSlotId" @click="submit">
                {{ busy ? 'Переношу…' : 'Перенести' }}
            </button>
            <button class="btn" @click="$emit('close')">Отмена</button>
        </div>
    </dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { request } from '@/admin/shared/api/httpClient';

const props = defineProps<{ open: boolean; orderItemId: () => string }>();
const emit = defineEmits<{ (e: 'close'): void; (e: 'done'): void }>();

const newSlotId = ref('');
const busy = ref(false);

async function submit(): Promise<void> {
    busy.value = true;
    try {
        // TODO(v2-cutover): /admin-api/consultation-bookings/<id>/reschedule/ was
        // removed with the ConsultationBooking model. V2 reschedule runs through
        // commerce reserve_consultation_slot (sets the 'rescheduled' flag on the
        // OrderItem's Reservation). Re-point at the V2 admin reservations
        // reschedule action resolved from the OrderItem,
        // i.e. POST /admin-api/reservations/<reservation_id>/reschedule/. Requires
        // BE coordination for orderItemId -> reservation resolution.
        await request({
            method: 'post',
            url: `/admin-api/reservations/${props.orderItemId()}/reschedule/`,
            data: { new_slot_id: newSlotId.value },
        });
        emit('done');
    } finally {
        busy.value = false;
    }
}
</script>

<style scoped>
.action-dialog {
    padding: 1.5rem;
    border-radius: var(--admin-radius-sm);
    border: 1px solid var(--admin-border);
    box-sizing: border-box;
    /* только max-width: на десктопе диалог остаётся fit-content, как был */
    max-width: min(440px, 92vw);
    max-height: 90vh;
    overflow-y: auto;
}
.action-dialog label {
    display: block;
    margin-bottom: 0.75rem;
}
.action-dialog input {
    width: 100%;
    font-family: monospace;
    margin-top: 0.25rem;
}
.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
}

@media (max-width: 640px) {
    /* iOS зумит страницу при фокусе, если шрифт поля меньше 1rem */
    .action-dialog input { font-size: 1rem; min-height: 2.5rem; }
    .actions .btn { min-height: 2.5rem; }
}
</style>
